import React, { Component } from "react";
import "../LandingPage/LandingPageStyleSheet.css";
import AgentConversationList from "../LandingPage/AgentConversationList";
import HWUser from "../HWLibrary/HWUser";
import wavingHandImage from "../../images/waving-hand.svg";
import { isNullOrUndefined } from "../HWLibrary/HWUtils";
import { MyContext } from "../../context/Mycontext";

class LandingPageHeader extends Component {
  // assigning context to current page context
  static contextType = MyContext;

  onClose = () => {
    this.props.actions &&
      this.props.actions.onHideChatWindow &&
      this.props.actions.onHideChatWindow();
    this.props.actions.onStartUpClick();
  };

  pageHeaderStyle = () => {
    return {
      background:
        this.props.config.designDetails?.headerBackgroundImage !== undefined &&
        this.props.config.designDetails?.headerBackgroundImage !== ""
          ? "url(" + this.props.config.designDetails?.headerBackgroundImage + ")"
          : this.props.config.designDetails.headerTopColor,
    };
  };
  headerMessageStyle = () => {
    return {
      background:
        this.props.config.designDetails.headerBackgroundImage !== undefined &&
        this.props.config.designDetails.headerBackgroundImage !== ""
          ? "url(" + this.props.config.designDetails?.headerBackgroundImage + ")"
          : this.props.config.designDetails.headerMessageBackgroundColor,
      color: this.props.config.designDetails.headerFontColor,
    };
  };
  headerStyle = () => {
    const design = this.props.config.designDetails;
    return {
      color: design.headerFontColor,
      fontFamily: design.headerFont,
      fontSize: design.headerFontSize + "px",
      backgroundColor: design.landingPageHeaderColor,
    };
  };
  headerIconStyle = () => {
    return {
      fill: isNullOrUndefined(this.props.config.designDetails.headerIconColor)
        ? "#1f175c"
        : this.props.config.designDetails.headerIconColor,
    };
  };
  agentIntroductoryMessage = () => {
    return {
      fontFamily: this.props.config.designDetails.messageFont,
      fontSize: this.props.config.designDetails.messageFontSize + "px",
      color: this.props.config.designDetails.messageFontColor,
    };
  };

  render() {
    const customerName = this.context.userData.customerFirstName;
    return (
      <div className="s360-landing-page-header" style={this.pageHeaderStyle()}>
        <div
          className="s360-landing-page-header-message"
          style={this.headerMessageStyle()}
        >
          <div
            className="s360-landing-page-header-salutation-message"
            style={this.headerStyle()}
          >
            <div
              className={
                localStorage.getItem("openInFullScreen")
                  ? "s360-conversation-header-details-image-fs"
                  : "s360-conversation-header-details-image"
              }
              style={{
                marginRight: `${this.props.config.designDetails.headerIconMarginRight}px` || "0px",
              }}
            >
              <div>
                <img
                  style={{
                    width: isNullOrUndefined(this.props.config.designDetails.iconWidth)
                      ? "50px"
                      : this.props.config.designDetails.iconWidth + "px",
                    height:
                      this.props.config.configDetails.headerMessage ===
                      "OOREDOO"
                        ? "42px"
                        : isNullOrUndefined(this.props.config.designDetails.iconHeight)
                        ? "31px"
                        : this.props.config.designDetails.iconHeight + "px",

                    marginLeft:
                      this.props.config.configDetails.headerMessage ===
                      "OOREDOO"
                        ? "-11px"
                        : "0px",
                    marginTop: "-10px",
                    cursor: "pointer",
                    objectFit: "scale-down",
                    borderRadius: `${this.props.config.designDetails.headerIconBorderRadius}px` || "0px",
                  }}
                  src={this.props.config.configDetails.brandIcon}
                  alt="/"
                ></img>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <p style={{ marginLeft: "15px" }}>
                {this.props.config.configDetails.header}
              </p>
            </div>
            {!customerName?.includes("-") && (
              <div className="s360-landing-page-header-customer-name">
                {customerName}
              </div>
            )}

            <button className="s360-default-header-icon" onClick={this.onClose}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13.624"
                height="53"
                viewBox="0 0 13.624 8.209"
              >
                <path
                  id="down-arrow"
                  d="M2370.983,5063.169a1,1,0,0,1-.73-.316l-5.812-6.209a1,1,0,0,1,1.46-1.367l5.082,5.429,5.082-5.429a1,1,0,0,1,1.46,1.367l-5.812,6.209A1,1,0,0,1,2370.983,5063.169Z"
                  transform="translate(-2364.171 -5054.96)"
                  style={this.headerIconStyle()}
                />
              </svg>
            </button>
          </div>
        </div>
        {this.props.config.configDetails.headerMessage !== "OOREDOO" && (
          <div
            className="s360-landing-page-header-sub-salutation-message"
            style={this.headerStyle()}
          >
            {this.props.config.configDetails.headerMessage}
          </div>
        )}
        {/* <div className="s360-landing-page-header-agent-container"> */}
        {/* <AgentConversationList {...this.props} /> */}
        {/* </div> */}
        <div
          className="s360-landing-page-header-information"
          style={this.agentIntroductoryMessage()}
        >
          {this.props.config.configDetails.agentIndroductionMessage}
        </div>
      </div>
    );
  }
}

export default LandingPageHeader;
